import DropDownSearch from '../../../../components/DropDownSearch';
import { useState, useEffect } from 'react';
import HesSpinner from '../../../../components/loadingOverlay/hesSpinner';
import { Button } from 'react-bootstrap';
import { useOutletContext } from 'react-router';
import { useQuestionSearchContext } from '../../components/castleQuestionsSearch/context';
import { useData } from '../../../assignments/ExamAndAssignmentsContext';
import PublicAssignments from './pages/publicAssignments';
import YourAssignments from './pages/yourAssignments';

const ExamsAndAssignments = () => {
  const [searchType, setSearchType] = useState('stateTests');
  const [, setSelectedIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(0);

  const { courseData, folderData } = useData();
  const outletContext = useOutletContext();
  const questionSearchContext = useQuestionSearchContext();

  const handleSelectionChange = (e, filterList, setFilterList) => {
    const { key } = e;
    const selected = (key !== '000') ? filterList.find((v) => v.id == key) : filterList;
    let tempValue = [];

    if (key === '000') {
      tempValue = filterList.map((item) => ({
        ...item,
        isChecked: !filterList.filter(item => item?.isChecked !== true).length < 1,
      }));
    } else {
      tempValue = filterList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setFilterList(tempValue);
  };

  const SearchQuestions = () => {
    var searchRequest = {
      pageNumber: 1,
      pageSize: 25
    };

    switch (searchType) {
    case 'stateTests':
      searchRequest.courseIds = questionSearchContext.examsTabSelectedCourses.filter(c => c.isChecked).map(c => c.id);
      searchRequest.levels = questionSearchContext.examsTabSelectedGrades.filter(g => g.isChecked).map(g => g.gradeId).flat(1);
      searchRequest.states = questionSearchContext.examsTabSelectedStates.filter(s => s.isChecked).map(s => s.id);
      searchRequest.years = questionSearchContext.examsTabSelectedExamYears.filter(y => y.isChecked).map(y => y.id);
      outletContext.initializeExamSearch(searchRequest);
      break;
    case 'yourAssignment':
      outletContext.initializeTeacherAssignmentSearch(selectedAssignmentId);
      break;
    case 'publicAssignment':
      outletContext.initializePublicAssignmentSearch(selectedAssignmentId);
      break;
    }
  };

  useEffect(() => {
    getAllCoursesAsync();
  }, [courseData]);

  useEffect(() => {
    getAllFoldersAsync();
  }, [folderData]);

  const getAllCoursesAsync = async () => {
    try {
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      const courseArray = [obj, ...courseData];
      courseArray !== null && courseArray !== undefined
        ? setCourses(courseArray)
        : setCourses([obj]);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllFoldersAsync = async () => {
    try {
      const folderArray = [];
      folderData.filter(item => item.folderID !== -88).map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        folderArray.push(obj);
      });
      const objData = {
        id: -1,
        name: 'Any Folder'
      };
      const FolderArrayResponse = [objData, ...folderArray];
      FolderArrayResponse !== null && FolderArrayResponse !== undefined
        ? setFolders(FolderArrayResponse)
        : setFolders([objData]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedAssignmentId != 0)
      SearchQuestions();
  }, [selectedAssignmentId]);

  useEffect(() => {
    outletContext.endCastleSearch();
  }, []);
  
  return (
    <>
      <div className='d-flex flex-column castleQuestionsSearchBox'>

        {outletContext.courseFilters.isError && <div className='d-flex w-100 justify-content-center align-items-center'>
          <button className='fs-error error btn-link' onClick={() => outletContext.fetchCourseFilters()}>There was an error getting your courses. Click to try again</button>
        </div>}

        {outletContext.courseFilters.isLoading && <div className='d-flex flex-row w-100 justify-content-center align-items-center'>
          <HesSpinner width='2%' />
          <span className='fs-2 ms-2'>Getting your courses...</span>
        </div>}

        {outletContext.courseFilters.isSuccess && <div className='castleQuestionsSearchTypeList mb-3'>
          <span className={`px-3 py-2 rounded-2 ${searchType == 'stateTests' ? 'active' : ''}`} onClick={() => { setSearchType('stateTests'); outletContext.endCastleSearch(); setSelectedAssignmentId(0); }}>State Tests</span>
          <span className={`px-3 py-2 rounded-2 ${searchType == 'yourAssignment' ? 'active' : ''}`} onClick={() => { setSearchType('yourAssignment'); outletContext.endCastleSearch(); setSelectedAssignmentId(0); }}>Your Assignments</span>
          <span className={`px-3 py-2 rounded-2 ${searchType == 'publicAssignment' ? 'active' : ''}`} onClick={() => { setSearchType('publicAssignment'); outletContext.endCastleSearch(); setSelectedAssignmentId(0); }}>Public Assignments</span>
        </div>}

        {searchType === 'stateTests' &&
          <>
            {outletContext.courseFilters.isSuccess && <div className='d-flex flex-row gap-3 mb-3 align-items-center'>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select Grade</span>
                <DropDownSearch
                  value={questionSearchContext.examsTabSelectedGrades}
                  setValue={questionSearchContext.setExamsTabSelectedGrades}
                  dropdownId='gradesFilter'
                  placeholder='Grades'
                  handleChange={(e) => handleSelectionChange(e, questionSearchContext.examsTabSelectedGrades, questionSearchContext.setExamsTabSelectedGrades)}
                  selectedId={questionSearchContext.examsTabSelectedGrades.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All Grades'
                />
              </div>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select Content Area</span>
                <DropDownSearch
                  value={questionSearchContext.examsTabSelectedCourses}
                  setValue={questionSearchContext.setExamsTabSelectedCourses}
                  dropdownId='contentAreaFilter'
                  placeholder='Content Area'
                  handleChange={(e) => handleSelectionChange(e, questionSearchContext.examsTabSelectedCourses, questionSearchContext.setExamsTabSelectedCourses)}
                  selectedId={questionSearchContext.examsTabSelectedCourses.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All Content Areas'
                />
              </div>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select State</span>
                <DropDownSearch
                  value={questionSearchContext.examsTabSelectedStates}
                  setValue={questionSearchContext.setExamsTabSelectedStates}
                  dropdownId='stateFilter'
                  placeholder='State'
                  handleChange={(e) => handleSelectionChange(e, questionSearchContext.examsTabSelectedStates, questionSearchContext.setExamsTabSelectedStates)}
                  selectedId={questionSearchContext.examsTabSelectedStates.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All States'
                />
              </div>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select Exam Year</span>
                <DropDownSearch
                  value={questionSearchContext.examsTabSelectedExamYears}
                  setValue={questionSearchContext.setExamsTabSelectedExamYears}
                  dropdownId='examYearFilter'
                  placeholder='Exam Year'
                  handleChange={(e) => handleSelectionChange(e, questionSearchContext.examsTabSelectedExamYears, questionSearchContext.setExamsTabSelectedExamYears)}
                  selectedId={questionSearchContext.examsTabSelectedExamYears.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All Exam Years'
                />
              </div>
              <Button variant='castleWhite w-30' className='mt-4' onClick={() => SearchQuestions()}
                disabled={questionSearchContext.isSearching ||
                  questionSearchContext.examsTabSelectedGrades.filter(g => g.isChecked)?.length == 0 ||
                  questionSearchContext.examsTabSelectedCourses.filter(c => c.isChecked)?.length == 0 ||
                  questionSearchContext.examsTabSelectedExamYears.filter(e => e.isChecked)?.length == 0 ||
                  questionSearchContext.examsTabSelectedStates.filter(s => s.isChecked)?.length == 0}>
                Search
              </Button>
            </div>}
          </>
        }
        {searchType === 'yourAssignment' &&
          <YourAssignments
            courses={courses}
            folders={folders}
            setSelectedAssignmentId={setSelectedAssignmentId}
          />
        }
        {searchType === 'publicAssignment' &&
          <PublicAssignments
            courses={courses}
            setSelectedAssignmentId={setSelectedAssignmentId}
          />
        }
      </div >
    </>
  );
};

export default ExamsAndAssignments;
